import { testnetConfig } from "./testnet";
import { mainnetConfig } from "./mainnet";

const network = process.env.NEXT_PUBLIC_NETWORK || "mainnet";

export const config = network === "mainnet" ? mainnetConfig : testnetConfig;
